import localforage from 'localforage'


const emptyDbResponse = (): Promise<null> => new Promise( resolve => resolve(null) )


class Persistence {

  db: LocalForage | null

  constructor(){
    this.db = null
  }

  getActiveDb(): LocalForage | null {
    return this.db
  }

  hasActiveDb(): boolean {
    return this.db !== null
  }

  drop(): Promise<void | null> {
    return this.db && this.db.dropInstance() || emptyDbResponse()
  }

  selectDb(name: string): void {
    if ( this.db === null ){
      this.db = localforage.createInstance({ name })
    }
  }

  get(key: string): Promise<unknown> {
    return this.db && this.db.getItem(key) || emptyDbResponse()
  }

  set(key: string, value: unknown): Promise<unknown> {
    return this.db && this.db.setItem(key, value) || emptyDbResponse()
  }

  delete(key: string): Promise<unknown> {
    return this.db && this.db.removeItem(key) || emptyDbResponse()
  }

  clear(): Promise<unknown> {
    return this.db && this.db.clear() || emptyDbResponse()
  }

}


export const persistence = new Persistence()
